import React from 'react'
import styled from 'styled-components'
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa'

export default function RatingPlusOrMinus({
  isOverall,
  criteriaName,
  rateWithPlusOrMinus,
  handleChangeRatingWithPlusOrMinus
}) {
  if (isOverall) {
    return <div />
  }

  return (
    <Wrapper status={rateWithPlusOrMinus[criteriaName]}>
      <button
        type="button"
        className="minus-btn"
        onClick={() => handleChangeRatingWithPlusOrMinus(criteriaName, 'minus')}
      >
        <FaMinusCircle />
      </button>
      <button
        type="button"
        className="plus-btn"
        onClick={() => handleChangeRatingWithPlusOrMinus(criteriaName, 'plus')}
      >
        <FaPlusCircle />
      </button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  button {
    background: transparent;
    border: none;
    cursor: pointer;
  }

  svg {
    width: 20px;
    height: 20px;
  }

  .minus-btn {
    &:hover {
      svg {
        fill: #ff9999;
      }
    }
    svg {
      fill: ${props => (props.status === 'minus' ? '#f00' : '#bfbfbf')};
    }
  }

  .plus-btn {
    &:hover {
      svg {
        fill: #7fdd7f;
      }
    }
    svg {
      fill: ${props => (props.status === 'plus' ? '#00bc00' : '#bfbfbf')};
    }
  }
`
